import AuthService from "@services/auth.service";
import Config from "@config";
import { sha256 } from "@crypto";
import { getSession, setSession, clearSession } from "@hooks/useSession";
import NavigationService from "@services/navigation.service.js";
import State, { STATE, LoginFlowState, InvitationState, CurrentEntityState } from "@state";
import EntityService from "../services/entity.service";
import invitationService from "../services/invitation.service";
import UserService from "../services/user.service";

/**
 * Login a patient with e-mail & password.
 * Returns backend payload on success, or a standardised error object on failure.
 */
const login = async (email, password) => {
  // Basic front-side validation
  const missingFields = [];
  if (!email) missingFields.push("email");
  if (!password) missingFields.push("password");

  if (missingFields.length > 0) {
    return {
      success: false,
      message: `Missing fields: [${missingFields.join(", ")}]`,
      fromError: null,
      errorCode: "auth-login-validation-error",
      missingFields: "[" + missingFields.join(", ") + "]",
      errorKey: 922001,
    };
  }

  // Hash sensitive fields before transmission
  const hashedEmail = await sha256(email);
  const hashedPassword = await sha256(password);
  const hashedPassword2 = await sha256(hashedPassword);

  const payload = {
    email: email,
    hashedEmail: hashedEmail,
    password: hashedPassword,
    password2: hashedPassword2,
  };

  const result = await AuthService.login(payload);

  console.log("=== result === auth.controller.js === key: 616324 ===");
  console.dir(result, { depth: null, colors: true });
  console.log("=================================");

  if (result?.success === false) {
    clearSession();
    return result;
  }

  if (
    STATE[InvitationState.INVITATION_TYPE] ===
    InvitationState.INVITATION_TYPE_JOIN_CRO
  ) {
    const joinCroResult = await EntityService.joinCro();
    console.log("=== joinCroResult === auth.controller.js === key: 955531 ===");
    console.dir(joinCroResult, { depth: null, colors: true });
    console.log("=================================");

    const session = getSession();

    console.log('=== session === auth.controller.js === key: 091065 ===');
    console.dir(session, { depth: null, colors: true })
    console.dir(STATE, { depth: null, colors: true })
    console.log('=================================');
    

    if (joinCroResult?.success !== false) {
      // Call addAdmin to register current user as admin of the new CRO entity
      try {
        const entityId = STATE[InvitationState.INVITATION_CONTENT].entity_id;
        const userId = session?.user?.userId;

        if (entityId && userId) {
          const addAdminRes = await EntityService.addAdmin({
            entityId,
            userId,
            accepted: true,
          });
          console.log("=== addAdminRes === auth.controller.js === key: 271034 ===");
          console.dir(addAdminRes, { depth: null, colors: true });
          console.log("=================================");
        } else {
          console.warn(
            "addAdmin skipped: missing entityId or userId.",
            entityId,
            userId
          );
        }
      } catch (addAdminErr) {
        console.error("Error while calling addAdmin:", addAdminErr);
      }
      const joined = await invitationService.joinInvitation(
        STATE[InvitationState.INVITATION_CONTENT].id
      );
      console.log("=== joined === auth.controller.js === key: 388049 ===");
      console.dir(joined, { depth: null, colors: true });
      console.log("=================================");
    }
  }

  /*const user = {
    firstname: result?.firstname,
    lastname: result?.lastname,
    didAddress: result?.didAddress,
    userId: result.webhook?.response?.data.userId,
    role: result.webhook?.response?.data.role||"unknown",
    email,
  }


  const sessionObject = {
    platformToken: result.webhook?.response?.data.token,
    apiToken: result.token,
    user,
  }

  console.log('=== sessionObject === auth.controller.js === key: 831047 ===');
  console.dir(sessionObject, { depth: null, colors: true })
  console.log('=================================');

  setSession(sessionObject);*/

  if (
    STATE[InvitationState.INVITATION_TYPE] ===
    InvitationState.INVITATION_TYPE_NEW_CRO
  ) {
    State.reset(InvitationState);
    State.reset(LoginFlowState);
    NavigationService.navigateTo("/cro-create-company-signup");
  } else if (
    STATE[InvitationState.INVITATION_TYPE] ===
    InvitationState.INVITATION_TYPE_JOIN_STUDY_PATIENT
  ) {

    console.log('=== STATE === auth.controller.js === key: 268466 ===');
    console.dir(STATE, { depth: null, colors: true })
    console.log('=================================');

    const investigatorId = STATE[InvitationState.INVITATION_CONTENT].investigator_id;
    const studyId = STATE[InvitationState.INVITATION_CONTENT].study_id;

    
    

    State.reset(InvitationState);
    State.reset(LoginFlowState);
    console.log('=== STATE === auth.controller.js === key: 712094 ===');
    console.dir(STATE, { depth: null, colors: true })
    console.log('=================================');
    //return;
    NavigationService.navigateTo("/dashboard");
  } else {
    NavigationService.navigateTo("/dashboard");
  }

  return result;
};

// Signup new user (only console log for now)
const signup = async (userData) => {
  try {
    const { email: clearEmail, password, confirmPassword, ...rest } = userData;

    if (!clearEmail || !password || !confirmPassword) {
      return {
        success: false,
        message: "Missing mandatory fields",
        fromError: null,
        errorCode: "auth-signup-validation-error",
        errorKey: 832114,
      };
    }

    if (password !== confirmPassword) {
      return {
        success: false,
        message: "Passwords do not match",
        fromError: null,
        errorCode: "auth-password-mismatch",
        errorKey: 776421,
      };
    }

    let uesrRole = "unknown";
    if (
      STATE[InvitationState.INVITATION_TYPE] ===
      InvitationState.INVITATION_TYPE_NEW_CRO
    ) {
      uesrRole = "cro";
    }
    if (
      STATE[InvitationState.INVITATION_TYPE] ===
      InvitationState.INVITATION_TYPE_JOIN_CRO
    ) {
      uesrRole = "cro";
    }
    if (
      STATE[InvitationState.INVITATION_TYPE] ===
      InvitationState.INVITATION_TYPE_JOIN_STUDY_PATIENT
    ) {
      uesrRole = "participant";
    }
    if (
      STATE[InvitationState.INVITATION_TYPE] ===
      InvitationState.INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR
    ) {
      uesrRole = "investigator";
    }
   

    const hashedEmail = await sha256(clearEmail);
    const hashedPassword = await sha256(password);
    const hashedPassword2 = await sha256(hashedPassword);

    const payload = {
      emailClear: clearEmail,
      email: hashedEmail,
      password: hashedPassword,
      password2: hashedPassword2,
      ...rest,
      role: uesrRole,
    };

    console.log("=== payload === auth.controller.js === key: 751193 ===");
    console.dir(payload, { depth: null, colors: true });
    console.log("=================================");

    const signupResult = await AuthService.signup(payload);

    console.log("=== signupResult === auth.controller.js === key: 086403 ===");
    console.dir(signupResult, { depth: null, colors: true });
    console.log("=================================");

    if (signupResult?.success === false) {
      return signupResult;
    }

    const loginResult = await login(clearEmail,password);
    if (loginResult?.success === false) {
      await clearSession();
      return loginResult;
    }

    /** ------------------ cmt 453653 ------------------
    if (
      STATE[InvitationState.INVITATION_TYPE] ===
      InvitationState.INVITATION_TYPE_NEW_CRO
    ) {
      State.reset(InvitationState);
      NavigationService.navigateTo("/cro-create-company-signup");
    } else if (
      STATE[InvitationState.INVITATION_TYPE] ===
      InvitationState.INVITATION_TYPE_JOIN_STUDY_PATIENT
    ) {
      console.log('=== STATE === auth.controller.js === key: 634989 ===');
      console.dir(STATE, { depth: null, colors: true })
      console.log('=================================');
      return;
      State.reset(InvitationState);
      NavigationService.navigateTo("/dashboard");
    } else {
      State.reset(InvitationState);
      NavigationService.navigateTo("/dashboard");
    }
    *-------------------------------------------------*/

    return loginResult;
  } catch (error) {
    console.log("=== error === auth.controller.js === key: 086443 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return {
      success: false,
      message: "Unexpected error",
      fromError: error,
      errorCode: "auth-signup-exception",
      errorKey: 560998,
    };
  }
};

const isUserRegistered = async (email) => {
  const hashedEmail = await sha256(email);
  const result = await AuthService.isUserRegistered(hashedEmail);
  return result;
};

const logout = (path = "/") => {
  //reset();
  clearSession();
  State.reset();
  NavigationService.navigateTo(path);
};

const AuthController = {
  login,
  signup,
  logout,
  isUserRegistered,
};

export default AuthController;
